const requireLang = require.context('./', false, /\.json$/);
const langFiles = requireLang.keys().map((file) => file.replace('./', ''));

export default langFiles;